export default __webpack_public_path__ + "static/media/img (1).ee31927b.jpg";